import { ContentCopy, EditLocationAlt } from '@mui/icons-material'
import { Box } from '@mui/material'

import { ActionBar as TidalActionBar } from '@workwave-tidal/core/components'
import { ActionBarItem, ActionBarProps } from '@workwave-tidal/core/components/ActionBar'
import { MoreHoriz } from '@workwave-tidal/core/icons'

import { useTexts } from '../hooks/useTexts'

export function ActionBar(props: ActionBarProps) {
  const { actions } = useTexts()

  return (
    // this padding will align the actionBar with the text field
    <Box pt={2}>
      <TidalActionBar limit={0} menuIcon={<MoreHoriz />} {...props}>
        <ActionBarItem
          id="adjust-address"
          label={actions.adjustAddress}
          icon={<EditLocationAlt />}
        />
        <ActionBarItem
          id="copy-coordinates"
          label={actions.copyCoordinates}
          icon={<ContentCopy />}
        />
      </TidalActionBar>
    </Box>
  )
}
